import styled from 'styled-components';
import { rem } from 'polished';
var ModalCloseButton = styled.button.withConfig({
  displayName: "ModalCloseButton",
  componentId: "sc-5yccnj-0"
})(["appearance:none;background-color:transparent;border:0;cursor:pointer;opacity:0.7;padding:0;position:absolute;right:", ";top:", ";transition:opacity 0.15s ease-in-out;&:hover{opacity:1;}&:focus{outline:none;}"], rem(8), rem(8));
export default ModalCloseButton;